export default __webpack_public_path__ + "static/kb_1_main-72d5d086c2eb3e836f775381d47e35e6.jpeg";